// Capelli — filtra galería por color, dots propios (2 = vistas del color) + "+" zoom mobile.
(function () {
  function selectedColor() {
    var inp = document.querySelector('input[data-option-name="Color"]:checked');
    return inp ? (inp.value || '').trim() : null;
  }
  function visibleCarouselSlides() {
    var carousel = document.querySelector('.product-information__media slideshow-component');
    if (!carousel) return [];
    return Array.from(carousel.querySelectorAll('slideshow-slide'))
      .filter(function (s) { return getComputedStyle(s).display !== 'none'; });
  }
  function apply() {
    var color = selectedColor();
    if (!color) return;
    var slides = document.querySelectorAll(
      '.product-information__media li.product-media-container, ' +
      '.product-information__media slideshow-slide, ' +
      '.dialog-zoomed-gallery__dialog li.product-media-container, ' +
      '.dialog-zoomed-gallery__dialog slideshow-slide, ' +
      '.dialog-thumbnails-list button, ' +
      '.dialog-thumbnails-list li'
    );
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      if (!alt) return;
      var disp = alt.indexOf(color) !== -1 ? '' : 'none';
      if (s.style.display !== disp) s.style.display = disp;
    });
    renderCapDots();
  }
  function renderCapDots() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    var carousel = media.querySelector('slideshow-component');
    if (!carousel) return;
    if (getComputedStyle(carousel).position === 'static') carousel.style.position = 'relative';
    var slides = visibleCarouselSlides();
    var dotsEl = media.querySelector('.cap-dots');
    if (!dotsEl) {
      dotsEl = document.createElement('div');
      dotsEl.className = 'cap-dots';
      carousel.appendChild(dotsEl);
    }
    if (dotsEl.children.length !== slides.length) {
      dotsEl.innerHTML = '';
      slides.forEach(function (s) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cap-dot';
        d.setAttribute('aria-label', 'Vista');
        d.addEventListener('click', function (e) {
          e.stopPropagation();
          s.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dotsEl.appendChild(d);
      });
    }
    updateCapDotsActive();
  }
  function updateCapDotsActive() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    var carousel = media.querySelector('slideshow-component');
    var dotsEl = media.querySelector('.cap-dots');
    if (!carousel || !dotsEl) return;
    var slides = visibleCarouselSlides();
    var cr = carousel.getBoundingClientRect();
    var center = cr.left + cr.width / 2;
    var active = 0, best = Infinity;
    slides.forEach(function (s, i) {
      var r = s.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - center);
      if (d < best) { best = d; active = i; }
    });
    Array.from(dotsEl.children).forEach(function (d, i) {
      d.classList.toggle('cap-dot--active', i === active);
    });
  }
  function ensureMobileZoom() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    var host = media.querySelector('slideshow-component') || media;
    if (media.querySelector('.cap-mobile-zoom')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cap-mobile-zoom';
    btn.setAttribute('aria-label', 'Ampliar');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var slide = Array.from(media.querySelectorAll('slideshow-slide, .media-gallery__grid li.product-media-container'))
        .find(function (s) { return getComputedStyle(s).display !== 'none' && s.getBoundingClientRect().width > 50; });
      var img = slide ? slide.querySelector('img') : null;
      if (img) img.click();
    });
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(btn);
  }
  function bindScroll() {
    var media = document.querySelector('.product-information__media');
    if (!media || media.__capScroll) return;
    var carousel = media.querySelector('slideshow-component');
    if (!carousel) return;
    media.__capScroll = true;
    carousel.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateCapDotsActive);
    }, { passive: true, capture: true });
  }
  function init() {
    apply();
    ensureMobileZoom();
    bindScroll();
    var c = document.querySelector('.product-information__media');
    if (c && !c.__capObs) {
      var o = new MutationObserver(function () { apply(); ensureMobileZoom(); bindScroll(); });
      o.observe(c, { childList: true, subtree: true });
      c.__capObs = o;
    }
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[data-option-name="Color"]')) {
      setTimeout(apply, 80);
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-media-container__zoom-button')) {
      setTimeout(apply, 220);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
